/* Shelving Racking Co masthead (8-10-2026) */
(function () {
  var srm = document.querySelector('[data-srm]');
  if (!srm || srm.__srm) return;
  srm.__srm = true;
  var CFG = window.SRM || {};
  var doc = document.documentElement;
  var section = srm.closest('.shopify-section') || srm.parentNode;
  function $(s, el) { return (el || srm).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || srm).querySelectorAll(s)); }
  function isDesk() { return window.matchMedia('(min-width: 1024px)').matches; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) {
    var n = typeof v === 'number' ? v / 100 : parseFloat(v);
    if (!isFinite(n)) return '';
    var amt = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (CFG.money || '£{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt).replace(/<[^>]+>/g, '');
  }

  var tb = $('.srm-tb'), head = $('[data-srm-head]'), nav = $('.srm-nav');
  var scrim = $('[data-srm-scrim]');
  var sticky = $('[data-srm-sticky]');

  /* ---------- open / closed status (UK time) ---------- */
  (function () {
    var dot = $('[data-srm-dot]'), st = $('[data-srm-status]');
    if (!st) return;
    var days = (srm.getAttribute('data-open-days') || '1,2,3,4,5').split(',').map(function (d) { return parseInt(d, 10); });
    var from = srm.getAttribute('data-open') || '08:30', to = srm.getAttribute('data-close') || '17:00';
    function mins(t) { var p = t.split(':'); return parseInt(p[0], 10) * 60 + parseInt(p[1] || 0, 10); }
    var names = ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    function tick() {
      var wd, h, m;
      try {
        var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
        parts.forEach(function (p) { if (p.type === 'weekday') wd = names.indexOf(p.value.slice(0, 3)); if (p.type === 'hour') h = parseInt(p.value, 10) % 24; if (p.type === 'minute') m = parseInt(p.value, 10); });
      } catch (e) { return; }
      var now = h * 60 + m, open = days.indexOf(wd) > -1 && now >= mins(from) && now < mins(to);
      dot.classList.toggle('is-open', open);
      if (open) { st.textContent = 'Open now'; return; }
      if (days.indexOf(wd) > -1 && now < mins(from)) { st.textContent = 'Closed · opens ' + from; return; }
      var n = wd;
      for (var i = 0; i < 7; i++) { n = n % 7 + 1; if (days.indexOf(n) > -1) break; }
      st.textContent = 'Closed · opens ' + names[n] + ' ' + from;
    }
    tick();
    setInterval(tick, 60000);
  })();

  /* ---------- wishlist count ---------- */
  function wl() {
    var n = 0;
    try {
      var raw = localStorage.getItem('rw_wishlist');
      if (raw) { var v = JSON.parse(raw); n = Array.isArray(v) ? v.length : (v && typeof v === 'object' ? Object.keys(v).length : 0); }
    } catch (e) {}
    $$('[data-srm-wl]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
  }
  wl();
  window.addEventListener('storage', function (e) { if (e.key === 'rw_wishlist') wl(); });
  document.addEventListener('click', function () { setTimeout(wl, 80); }, true);

  /* ---------- basket count + "added" panel ---------- */
  var added = $('[data-srm-added]'), addedTimer;
  function paint(count) { $$('[data-srm-count]').forEach(function (b) { b.textContent = count; b.hidden = !count; }); }
  function refresh(cb) {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint(c.item_count); if (cb) cb(c); })
      .catch(function () {});
  }
  function showAdded(item) {
    if (!added || /\/cart\/?$/.test(location.pathname)) return;
    var box = $('[data-srm-addeditem]', added), sub = $('[data-srm-addedsub]', added);
    if (item && item.items && item.items.length) item = item.items[0];
    if (item && (item.product_title || item.title)) {
      var img = item.featured_image && item.featured_image.url || item.image;
      if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '$1$2').replace(/\?.*$/, '') + '?width=160';
      var vt = item.variant_title && !/default title/i.test(item.variant_title) ? item.variant_title : '';
      box.innerHTML = (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64">' : '') +
        '<span><b>' + esc(item.product_title || item.title) + '</b>' + (vt ? '<small>' + esc(vt) + '</small>' : '') +
        '<small>Qty ' + esc(item.quantity || 1) + (item.final_line_price != null ? ' · ' + esc(money(item.final_line_price)) : '') + '</small></span>';
      box.hidden = false;
    } else { box.innerHTML = ''; box.hidden = true; }
    sub.textContent = '';
    refresh(function (c) { sub.textContent = 'Basket: ' + c.item_count + (c.item_count === 1 ? ' item' : ' items') + ' · ' + money(c.total_price); });
    added.hidden = false;
    clearTimeout(addedTimer);
    addedTimer = setTimeout(function () { added.hidden = true; }, 9000);
  }
  if (added) {
    $('[data-srm-addedx]', added).addEventListener('click', function () { added.hidden = true; });
    added.addEventListener('mouseenter', function () { clearTimeout(addedTimer); });
  }
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function onCart(url, ok, body) {
    if (!ok) return;
    if (/\/cart\/add/.test(url)) {
      var j = null;
      try { j = typeof body === 'string' ? JSON.parse(body) : body; } catch (e) {}
      showAdded(j);
    } else { refresh(); }
  }
  if (window.fetch && !window.fetch.__srm) {
    var of = window.fetch;
    var nf = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (CART_RE.test(url)) {
        p.then(function (r) {
          if (/\/cart\/add/.test(url)) { r.clone().text().then(function (t) { onCart(url, r.ok, t); }).catch(function () { onCart(url, r.ok, null); }); }
          else onCart(url, r.ok, null);
        }).catch(function () {});
      }
      return p;
    };
    nf.__srm = true;
    window.fetch = nf;
  }
  (function () {
    var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    if (XO.__srm) return;
    XMLHttpRequest.prototype.open = function (m, u) { this.__srmUrl = u; return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.open.__srm = true;
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (CART_RE.test(String(x.__srmUrl || ''))) x.addEventListener('load', function () { var t = null; try { t = x.responseText; } catch (e) {} onCart(String(x.__srmUrl), x.status >= 200 && x.status < 300, t); });
      return XS.apply(this, arguments);
    };
  })();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  /* ---------- scrim ---------- */
  var layers = {};
  function setLayer(k, on) {
    layers[k] = on;
    var any = Object.keys(layers).some(function (x) { return layers[x]; });
    scrim.hidden = !any;
  }
  scrim.addEventListener('click', function () { closeMega(); closePop(); closeDrawer(); });

  /* ---------- mega menus ---------- */
  var items = $$('[data-srm-item]'), openItem = null, openT, closeT;
  function openMega(li) {
    if (openItem === li) return;
    if (openItem) closeMega(true);
    closePop();
    var b = $('[data-srm-navbtn]', li), m = $('.srm-mega', li);
    b.setAttribute('aria-expanded', 'true'); m.hidden = false; openItem = li;
    setLayer('mega', true);
  }
  function closeMega(keepScrim) {
    clearTimeout(openT);
    if (!openItem) return;
    $('[data-srm-navbtn]', openItem).setAttribute('aria-expanded', 'false');
    $('.srm-mega', openItem).hidden = true;
    openItem = null;
    if (!keepScrim) setLayer('mega', false);
  }
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  items.forEach(function (li) {
    var b = $('[data-srm-navbtn]', li);
    b.addEventListener('click', function () { if (openItem === li) closeMega(); else openMega(li); });
    li.addEventListener('mouseenter', function () {
      if (!finePointer.matches) return;
      clearTimeout(closeT); clearTimeout(openT);
      openT = setTimeout(function () { openMega(li); }, openItem ? 0 : 140);
    });
    li.addEventListener('mouseleave', function () {
      if (!finePointer.matches) return;
      clearTimeout(openT);
      closeT = setTimeout(function () { if (openItem === li) closeMega(); }, 220);
    });
    li.addEventListener('focusout', function (e) { if (openItem === li && !li.contains(e.relatedTarget)) closeMega(); });
  });

  /* ---------- search popup ---------- */
  var pop = $('[data-srm-pop]'), idle = $('[data-srm-idle]'), res = $('[data-srm-res]');
  var activeForm = null, reqId = 0, timer;
  function place() {
    if (!activeForm || pop.hidden) return;
    var r = activeForm.getBoundingClientRect();
    var vw = doc.clientWidth, top = r.bottom + (isDesk() ? 8 : 10), left, width;
    if (!isDesk()) { left = 0; width = vw; }
    else {
      var w = activeForm.closest('.srm-w'), wr = w.getBoundingClientRect(), cs = getComputedStyle(w);
      var inL = wr.left + parseFloat(cs.paddingLeft), inR = wr.right - parseFloat(cs.paddingRight);
      left = r.left; width = inR - left;
      if (width < 980) { left = inL; width = inR - inL; }
    }
    pop.style.top = top + 'px'; pop.style.left = left + 'px'; pop.style.width = width + 'px';
    pop.style.maxHeight = Math.max(240, window.innerHeight - top - 12) + 'px';
    if (r.bottom < 0) closePop();
  }
  function openPop(form) {
    closeMega(true);
    if (drawerOpen) closeDrawer();
    activeForm = form;
    pop.hidden = false;
    setLayer('pop', true);
    place();
    var q = $('[data-srm-q]', form).value.trim();
    if (q.length > 1) suggest(q); else showIdle();
  }
  function closePop() {
    if (pop.hidden) return;
    pop.hidden = true; activeForm = null; setLayer('pop', false);
  }
  function showIdle() { idle.hidden = false; res.hidden = true; res.innerHTML = ''; }
  function hl(text, q) {
    var t = esc(text);
    q.split(/\s+/).filter(function (w) { return w.length > 1; }).forEach(function (w) {
      var re = new RegExp('(' + esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      t = t.replace(re, '<mark>$1</mark>');
    });
    return t;
  }
  function suggest(q) {
    var id = ++reqId;
    var url = (CFG.suggest || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
      if (id !== reqId || pop.hidden) return;
      var R = (j.resources && j.resources.results) || {};
      var cols = R.collections || [], prods = R.products || [];
      var h = '';
      if (cols.length) {
        h += '<p class="srm-res__h">Categories</p><div class="srm-res__cols">' + cols.map(function (c) { return '<a class="srm-chip" href="' + esc(c.url) + '">' + hl(c.title, q) + '</a>'; }).join('') + '</div>';
      }
      if (prods.length) {
        h += '<p class="srm-res__h">Products</p><div class="srm-res__list">' + prods.map(function (p) {
          var img = p.featured_image && p.featured_image.url || p.image;
          var from = p.price_min && p.price_max && p.price_min !== p.price_max;
          return '<a class="srm-res__p" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(String(img).replace(/\?.*$/, '')) + '?width=120" alt="" width="58" height="58" loading="lazy">' : '<i></i>') +
            '<span><b>' + hl(p.title, q) + '</b><small>' + (from ? 'From ' : '') + esc(money(from ? p.price_min : p.price)) + '</small></span></a>';
        }).join('') + '</div>';
      }
      if (!h) h = '<p class="srm-res__none">No exact matches for “' + esc(q) + '”. Try a size such as 1800 x 900 x 450, a load such as 300kg, or <a href="/pages/contact">ask us</a>.</p>';
      res.innerHTML = h; idle.hidden = true; res.hidden = false;
    }).catch(function () {});
  }
  $$('[data-srm-q]').forEach(function (inp) {
    var form = inp.form;
    inp.addEventListener('focus', function () { openPop(form); });
    inp.addEventListener('click', function () { if (pop.hidden) openPop(form); });
    inp.addEventListener('input', function () {
      if (pop.hidden) openPop(form);
      clearTimeout(timer);
      var q = inp.value.trim();
      if (q.length < 2) { reqId++; showIdle(); return; }
      timer = setTimeout(function () { suggest(q); }, 180);
    });
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePop(); inp.blur(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var links = $$('.srm-res__p', res);
        if (res.hidden || !links.length) return;
        e.preventDefault();
        var i = links.findIndex(function (a) { return a.classList.contains('is-active'); });
        i = e.key === 'ArrowDown' ? Math.min(links.length - 1, i + 1) : Math.max(-1, i - 1);
        links.forEach(function (a, k) { a.classList.toggle('is-active', k === i); });
        if (i > -1) links[i].scrollIntoView({ block: 'nearest' });
      }
      if (e.key === 'Enter') {
        var act = $('.srm-res__p.is-active', res);
        if (act && !res.hidden) { e.preventDefault(); location.href = act.href; }
      }
    });
    form.addEventListener('submit', function (e) {
      if (!inp.value.trim()) { e.preventDefault(); location.href = '/collections/all'; return; }
      if (!form.querySelector('input[name=type]')) { var t = document.createElement('input'); t.type = 'hidden'; t.name = 'type'; t.value = 'product'; form.appendChild(t); }
    });
  });
  $('[data-srm-all]').addEventListener('click', function () {
    var f = activeForm || $('.srm-search__form');
    if (f.requestSubmit) f.requestSubmit(); else f.submit();
  });
  document.addEventListener('mousedown', function (e) {
    if (pop.hidden) return;
    if (pop.contains(e.target) || (activeForm && activeForm.contains(e.target))) return;
    closePop();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (openItem) { var b = $('[data-srm-navbtn]', openItem); closeMega(); b.focus(); }
    if (!pop.hidden) closePop();
    if (drawerOpen) { closeDrawer(); }
    if (added && !added.hidden) added.hidden = true;
  });

  /* ---------- drawer ---------- */
  var drawer = $('[data-srm-drawer]'), burger = $('[data-srm-burger]'), deptBtn = $('[data-srm-depts]');
  var drawerOpen = false, drawerFrom = null, firstOpen = true;
  function placeDrawer() {
    if (!drawerOpen) return;
    var bar = drawerFrom === deptBtn ? sticky : head;
    drawer.style.setProperty('--srm-dtop', Math.max(0, bar.getBoundingClientRect().bottom) + 'px');
  }
  function openDrawer(btn) {
    closeMega(true); closePop();
    drawerOpen = true; drawerFrom = btn;
    drawer.hidden = false;
    placeDrawer();
    [burger, deptBtn].forEach(function (b) { if (b) b.setAttribute('aria-expanded', b === btn ? 'true' : 'false'); });
    if (burger) burger.setAttribute('aria-label', 'Close menu');
    if (firstOpen) { firstOpen = false; var a = $('[data-srm-acc]', drawer); if (a) toggleAcc(a, true); }
    doc.style.overflow = 'hidden';
    if (isDesk()) setLayer('drawer', true);
  }
  function closeDrawer() {
    if (!drawerOpen) return;
    drawerOpen = false; drawer.hidden = true;
    [burger, deptBtn].forEach(function (b) { if (b) b.setAttribute('aria-expanded', 'false'); });
    if (burger) burger.setAttribute('aria-label', 'Open menu');
    doc.style.overflow = '';
    setLayer('drawer', false);
  }
  [burger, deptBtn].forEach(function (b) {
    if (!b) return;
    b.addEventListener('click', function () { if (drawerOpen && drawerFrom === b) closeDrawer(); else openDrawer(b); });
  });
  function toggleAcc(btn, force) {
    var p = document.getElementById(btn.getAttribute('aria-controls'));
    var on = force != null ? force : btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    p.hidden = !on;
  }
  $$('[data-srm-acc]', drawer).forEach(function (b) { b.addEventListener('click', function () { toggleAcc(b); }); });
  $$('a', drawer).forEach(function (a) { a.addEventListener('click', function () { if (/#/.test(a.getAttribute('href') || '')) closeDrawer(); }); });

  /* ---------- sticky bar (desktop) + mobile stick offset ---------- */
  var stickOn = false;
  function setSticky(on) {
    if (on === stickOn) return;
    stickOn = on;
    sticky.classList.toggle('is-on', on);
    sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    $$('a,button,input', sticky).forEach(function (el) { if (el.type === 'hidden') return; if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
    if (!on) {
      if (drawerOpen && drawerFrom === deptBtn) closeDrawer();
      if (activeForm && sticky.contains(activeForm)) closePop();
    }
  }
  function onScroll() {
    if (isDesk()) {
      var b = srm.getBoundingClientRect().top + srm.offsetHeight;
      setSticky(b < 0);
    } else setSticky(false);
    place(); placeDrawer();
  }
  function onResize() {
    section.style.setProperty('--srm-stick', isDesk() ? '0px' : (-tb.offsetHeight) + 'px');
    if (isDesk() && drawerOpen && drawerFrom === burger) closeDrawer();
    if (!isDesk() && drawerOpen && drawerFrom === deptBtn) closeDrawer();
    if (!isDesk()) closeMega();
    onScroll();
  }
  var raf;
  window.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(onScroll); }, { passive: true });
  window.addEventListener('resize', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(onResize); });
  onResize();
})();
